import { Factory } from './Factory'
import Menu from '../EditorComponents/Lists/Menu'

export class ListsFactory extends Factory {
  constructor(qty = 1) {
    super()
    this.qty = qty
  }

  object() {
    return {
      id: this.id('lists'),
      slug: 'editor-lists',
      assets: {
        phone: [],
        tablet: [],
        desktop: []
      },
      background: {
        phone: 'color',
        tablet: 'color',
        desktop: 'color'
      },
      customClasses:[],
      name: 'Lists',
    }
  }

  properties() {
    return {
      content: [
        {key: 'has-icon', component:'ContentToggle', text:'has an Icon', property:'hasIcon'},
        {key: 'icon-content', component:'ContentIcon'},
        {key: 'has-description', component:'ContentToggle', text:'has an Description', property:'hasDescription'},
        {key: 'lists-padding', component: 'PaddingProperty'},
        {key: 'lists-margin', component: 'MarginProperty'},
      ],
      styles: [
        {key: 'item-border', component: 'BorderProperty', class:'itemClasses'},
        {key: 'item-font-size', component: 'FontSizeProperty', class:'itemClasses'},
        {key: 'item-font-weight', component: 'FontWeightProperty', class:'itemClasses'},
        {key: 'item-margin-top-bottom', component: 'MarginProperty', class: 'itemClasses'},
        {key: 'item-text-color', component: 'TextColorProperty', class: 'itemClasses'},
      ],
      iconStyles: [
        {key: 'background-color', component:'BackgroundProperty', only: ['color'], styles:'iconContainerStyles'},
        {key: 'border', component:'BorderProperty', class:'iconContainerClasses', styles: 'iconContainerStyles'},
        {key: 'rounded', component:'RoundedProperty', class:'iconContainerClasses'},
        {key: 'text-color', component:'TextColorProperty', styles: 'iconStyles'},
      ],
      descriptionStyles: [
        {key: 'desc-font-size', component: 'FontSizeProperty', class: 'descContainerClasses'},
        {key: 'desc-font-weight', component: 'FontWeightProperty', class: 'descContainerClasses'},
        {key: 'desc-text-color', component: 'TextColorProperty', styles: 'descStyles'},
      ],
      advanced: [
        {key: 'element-id', component: 'ElementId'},
        {key: 'custom-classes', component: 'CustomClasses'},
        {key: 'custom-styles', component: 'CustomStyles'},
      ],
      menu: Menu
    }
  }
}
